export const DEVICE_SOURCE_LIST_REQUEST = "DEVICE_SOURCE_LIST_REQUEST";
export const DEVICE_SOURCE_LIST_SUCCESS = "DEVICE_SOURCE_LIST_SUCCESS";
export const DEVICE_SOURCE_LIST_FAIL = "DEVICE_SOURCE_LIST_FAIL";

export const EQUIPMENT_LIST_REQUEST = "EQUIPMENT_LIST_REQUEST";
export const EQUIPMENT_LIST_SUCCESS = "EQUIPMENT_LIST_SUCCESS";
export const EQUIPMENT_LIST_FAIL = "EQUIPMENT_LIST_FAIL";

export const EQUIPMENT_DETAILS_REQUEST = "EQUIPMENT_DETAILS_REQUEST";
export const EQUIPMENT_DETAILS_SUCCESS = "EQUIPMENT_DETAILS_SUCCESS";
export const EQUIPMENT_DETAILS_FAIL = "EQUIPMENT_DETAILS_FAIL";
export const EQUIPMENT_DETAILS_CLEAR = "EQUIPMENT_DETAILS_CLEAR";

export const EQUIPMENT_CREATE_REQUEST = "EQUIPMENT_CREATE_REQUEST";
export const EQUIPMENT_CREATE_SUCCESS = "EQUIPMENT_CREATE_SUCCESS";
export const EQUIPMENT_CREATE_FAIL = "EQUIPMENT_CREATE_FAIL";

export const EQUIPMENT_UPDATE_REQUEST = "EQUIPMENT_UPDATE_REQUEST";
export const EQUIPMENT_UPDATE_SUCCESS = "EQUIPMENT_UPDATE_SUCCESS";
export const EQUIPMENT_UPDATE_FAIL = "EQUIPMENT_UPDATE_FAIL";